export default __webpack_public_path__ + "static/media/map-pin-doorway.7596df07.svg";